import React from 'react';

import { escape } from 'lodash';
import { Tooltip } from '@bringg/react-components';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { ResponseItem } from '@bringg/types';
import { DetailedCellProps } from '@bringg-frontend/monitoring';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';

import useOrderExplorerTranslations from '../../../use-order-explorer-translations';

const NextStopCell = ({ row }: DetailedCellProps<ResponseItem>) => {
	const { findMeDefaultAddress } = useOrderExplorerTranslations();

	const { way_points, active_way_point_id } = getRootEnv().dashboardSdk.sdk.v2.tasks.get(row.id);
	const activeWayPoint = (way_points || []).find(wp => wp.id === active_way_point_id);

	if (!activeWayPoint) return null;

	return (
		<>
			{!activeWayPoint.lat && (
				<Tooltip title="Address is not Geo-Located!">
					<BringgIcon iconName={BringgFontIcons.Location} color="#f0ad4e" />{' '}
				</Tooltip>
			)}
			{activeWayPoint.find_me ? findMeDefaultAddress : escape(activeWayPoint.address)}
		</>
	);
};

export default NextStopCell;
